import script from "./nChartsPie.vue?vue&type=script&setup=true&lang=js"
export * from "./nChartsPie.vue?vue&type=script&setup=true&lang=js"

import "./nChartsPie.vue?vue&type=style&index=0&id=65a4d991&lang=less"

const __exports__ = script;

export default __exports__